export const ADD_LOGIN_DETAILS = 'ADD_LOGIN_DETAILS';
export const REMOVE_LOGIN_DETAILS = 'REMOVE_LOGIN_DETAILS';